import { useMutation, useQueryClient } from '@tanstack/react-query';
import { terminologyApi } from '../api/terminologyApi';

/**
 * DELETE /api/eraf/terminology/forbidden-words/:id?mode=DEPRECATE
 */
export function useDeleteForbiddenWord() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, mode }: { id: number; mode?: 'DEPRECATE' | 'SOFT_DELETE' }) =>
      terminologyApi.deleteForbiddenWord(id, mode ?? 'DEPRECATE'),
    onSuccess: (_data, variables) => {
      void queryClient.invalidateQueries({
        queryKey: ['terminology', 'forbidden-words', 'list'],
      });
      void queryClient.invalidateQueries({
        queryKey: ['terminology', 'forbidden-words', 'detail', variables.id],
      });
      void queryClient.invalidateQueries({ queryKey: ['terminology', 'summary'] });
    },
  });
}
